import { Link } from 'react-router-dom';
import AnimatedLogo from '../base/AnimatedLogo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white">
      <div className="w-full px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
          {/* Company Info */}
          <div className="space-y-6">
            <AnimatedLogo isScrolled={false} />
            <p className="text-sm text-lightGrey leading-relaxed">
              Professional construction and rehabilitation services. Quality workmanship, reliable execution, and complete safety compliance for all your building needs.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="text-sm font-bold tracking-wider text-orange uppercase">
              Navigation
            </h3>
            <ul className="space-y-4">
              <li>
                <Link to="/services" className="text-white hover:text-orange hover:underline transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-orange hover:underline transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/" className="text-white hover:text-orange hover:underline transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-white hover:text-orange hover:underline transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white hover:text-orange hover:underline transition-colors cursor-pointer">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-6 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row items-center justify-center text-sm text-lightGrey">
            <p>© {currentYear} LEVANTINA. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
